<div class="nav-header flex flex-row items-center pg-left pg-right"
  [ngClass]="{ 'fixed': minimalHeader ? false : fixed, 'open' : sidebarDisplayed, 'collapsed': collapsed || hamburger }">
  @if (!this.isMobile || (this.isMobile && !searchVisible())) {
  <div class="nav-hamburger" (click)="toggleSidebar()">
    <img src="{{skinning.getImage('icon_menu')}}" />
    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M3 12H21" stroke="#293691" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"
        stroke-linejoin="round" />
        <path d="M5 5H19" stroke="#293691" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"
          stroke-linejoin="round" />
          <path d="M5 19H19" stroke="#293691" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"
            stroke-linejoin="round" />
          </svg> -->
  </div>
  }
  @if (!this.isMobile || (this.isMobile && !searchVisible())) {
  <div class="nav-logo flex flex-row items-center cursor-pointer" (click)="goHome()" data-testid="header_logo">
    <img src="{{skinning.getImage('logo')}}" />
  </div>
  }
  @if (searchVisible()) {
  <div class="nav-search flex flex-row items-center">
    <div class="search">
      <span class="search-button">
        <img src="{{skinning.getImage('icon_search')}}" />
      </span>
      <input #searchInput placeholder="{{ 'search.form.placeholder' | transloco }}" (input)="onSearchChange()"
        (keyup.enter)="onEnterKeyPressed()" [(ngModel)]="searchQuery" data-testid="header_search-field">
      @if (searchQuery) {
      <span class="close-button cursor-pointer" (click)="clearSearchQuery()">
        <img src="{{skinning.getImage('icon_close')}}" />
      </span>
      }
      <div class="custom-dropdown">
        <ul class="dropdown-list" [class.fade-list]="false && searchQuery">
          @for (item of ['test']; track item) {
          <li (click)="selectItem(item)">
            <!-- by the design, temp autocomplete not ready -->
            {{ item }}
          </li>
          }
        </ul>
      </div>
    </div>
  </div>
  }
  <!-- Inline menu items: -->
  @if (!minimalHeader && !searchVisible()) {
  <ul class="nav-items flex flex-row" data-testid="header_nav">
    @for (menuItem of items; track menuItem) {
    <li class="nav-item flex items-center" [ngClass]="{ 'active': menuItem.active }" [attr.alt]="menuItem.title"
      (click)="navigate(menuItem)" tabindex="0" [attr.data-testid]="'header_menu-'+(menuItem.testId || menuItem.id)">
      {{menuItem.title}}
    </li>
    }
  </ul>
  }
  <!-- Sidebar menu items: -->
  <ul class="nav-items sidebar flex flex-col" [ngClass]="{ 'open': sidebarDisplayed }">
    <li class="header-carpet"></li>
    @for (menuItem of items; track menuItem) {
    <li class="nav-item flex items-center" [attr.alt]="menuItem.title" (click)="navigate(menuItem)" tabindex="0"
      [attr.data-testid]="'header_menu-'+(menuItem.testId || menuItem.id)">
      <span class="nav-item-title">{{menuItem.title}}</span>
    </li>
    }
    @if (isMobile && (anonymous() || !customer())) {
    <hr class="divide">
    }
    @if (isMobile && (anonymous() || !customer())) {
    <li class="nav-item flex items-center" (click)="login()" tabindex="0" data-testid="header_sidebar-login">
      {{ 'login.button.title' | transloco }}
    </li>
    }
    @if (isMobile && (anonymous() || !customer())) {
    <li class="nav-item flex items-center" (click)="registration()" tabindex="0" data-testid="header_sidebar-registration">
      {{ 'login.button.register' | transloco }}
    </li>
    }
  </ul>
  <div class="nav-actions flex flex-row items-center">
    @if (!minimalHeader) {
    <!-- Cast session alive but mini player closed: only entry point to disconnect. -->
    @if (castSessionHidden() && !searchVisible()) {
    <rounded-icon-button style="position: relative;" (onClick)="disconnectCast()" [transparentBackground]="true"
      [imgSrc]="skinning.getImage('icon_cast_connected')" data-testid="header_cast"></rounded-icon-button>
    }
    <!-- Subscription notice pill (card confirmation), before search. Narrow screens collapse it to an icon. -->
    @if (!searchVisible() && !anonymous() && customer() && cardPreauthPill(); as pill) {
    @if (pill.compact) {
    <button type="button" class="sub-pill sub-pill--compact" [attr.aria-label]="pill.aria"
      (click)="cardPreauth.confirmCard()" data-testid="header_card-preauth">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <rect x="2" y="5" width="20" height="14" rx="2" />
        <path d="M2 10h20" />
      </svg>
      <span class="sub-pill__label">{{ pill.action }}</span>
    </button>
    } @else {
    <div class="sub-pill" [ngClass]="'sub-pill--' + pill.phase" role="status" tabindex="0" [attr.aria-label]="pill.aria"
      (click)="cardPreauth.confirmCard()" (keydown.enter)="cardPreauth.confirmCard()" data-testid="header_card-preauth">
      <span class="sub-pill__dot"></span>
      <span class="sub-pill__text" data-testid="header_card-preauth-status">
        {{ pill.lead }}
        @if (pill.strong) {
        <!-- explicit space: Angular drops whitespace at the start of a control-flow block -->
        {{ ' ' }}<strong>{{ pill.strong }}</strong>
        }
      </span>
      <button type="button" class="sub-pill__btn" (click)="$event.stopPropagation(); cardPreauth.confirmCard()"
        data-testid="header_card-preauth-action">{{ pill.action }}</button>
    </div>
    }
    }
    <!-- Free-days promo pill: the same pill in its promo variant, shown only while no card-confirmation
         notice is due. Collapses to the gift icon on narrow screens (full text in aria-label). -->
    @if (!searchVisible() && !anonymous() && customer() && promoPill(); as promo) {
    <div class="sub-pill sub-pill--promo" role="status" tabindex="0" [attr.aria-label]="promo.aria"
      (click)="cardPreauth.openPromoOffer()" (keydown.enter)="cardPreauth.openPromoOffer()" data-testid="header_promo">
      <svg class="sub-pill__gift" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <rect x="3" y="8" width="18" height="4" rx="1" />
        <path d="M12 8v13" />
        <path d="M19 12v9H5v-9" />
        <path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5" />
      </svg>
      <span class="sub-pill__text" data-testid="header_promo-status">{{ promo.lead }}</span>
      <button type="button" class="sub-pill__btn" (click)="$event.stopPropagation(); cardPreauth.openPromoOffer()"
        data-testid="header_promo-action">{{ promo.action }}</button>
    </div>
    }
    <rounded-icon-button style="position: relative;" (onClick)="toggleSearch(!searchVisible())"
      [transparentBackground]="true" [imgSrc]="skinning.getImage(searchVisible() ? 'icon_close' : 'icon_search')"
      data-testid="header_search"></rounded-icon-button>
    <!-- Anonymous user, login button: -->
    @if (!searchVisible() && (anonymous() || !customer()) && !this.isMobile) {
    <span class="nav-actions-auth flex flex-row items-center gap-3">
      <span>
        <button class="button button-sm secondary" (click)="login()" data-testid="header_login">
          {{ 'login.button.title' | transloco }}</button>
      </span>
      @if (settings.customerRegistrationEnabled()) {
      <span>
        <button class="button button-sm secondary" (click)="registration()" data-testid="header_registration">
          {{'login.button.register' | transloco }}</button>
      </span>
      }
    </span>
    }
    <!-- Profile/account options: -->
    @if (!searchVisible() && !anonymous() && customer(); as c) {
    <span class="dropdown hover-dropdown">
      <div class="cursor-pointer flex items-center justify-center relative">
        <rounded-icon-button style="position: relative;" [class.avatar]="!profile()?.imageUrl?.length"
          [bordered]="true" [imgFull]="!!profile()?.imageUrl?.length"
          [imgSrc]="profile()?.imageUrl?.length ? profile()!.imageUrl : skinning.getImage('icon_user')"
          data-testid="header_profile"></rounded-icon-button>
        @if (cardPreauthPill(); as pill) {
        <span class="avatar__dot" [class.avatar__dot--danger]="pill.phase === 'expired'" data-testid="header_profile-dot"></span>
        }
      </div>
      <div>
        <ul class="dropdown-menu header-dropdown dropdown-menu-right animate slideIn">
          <li class="dropdown-header pb-3 flex flex-row">
            <div class="avatar-profile flex items-center justify-center">
              <rounded-icon-button style="position: relative;" [class.avatar]="!profile()?.imageUrl?.length"
                [bordered]="true" [imgFull]="!!profile()?.imageUrl?.length"
                [imgSrc]="profile()?.imageUrl?.length ? profile()!.imageUrl : skinning.getImage('icon_user')"></rounded-icon-button>
            </div>
            <div class="info flex flex-col ps-5 font-small w-3/4">
              @if (profile(); as p) {
              <span class="truncate block">{{ p.name || c.firstName }}</span>
              }
              <span class="truncate block">{{ c.email || c.username }}</span>
            </div>
          </li>
          @if (profile()) {
          <li><a class="dropdown-item" (click)="changeProfile()" data-testid="header_profile_manage-profiles">
              <span class="dropdown-item-icon">
                <img src="{{skinning.getImage('icon_manage_profiles')}}" />
              </span>
              <span>
                {{'settings.profile.manage' | transloco}}
              </span>
            </a></li>
          }
          <li><a class="dropdown-item" (click)="openSettings()" data-testid="header_profile_settings">
              <span class="dropdown-item-icon">
                <img src="{{skinning.getImage('icon_tile_settings')}}" />
              </span>
              <span>
                {{'home.menu.settings' | transloco}}
              </span>
            </a></li>
          <li><a class="dropdown-item" (click)="openAccount()" data-testid="header_profile_account">
              <span class="dropdown-item-icon">
                <img src="{{skinning.getImage('icon_account')}}" />
              </span>
              <span>
                {{'account.manage' | transloco}}
              </span>
            </a></li>
          <li><a class="dropdown-item" (click)="logout()" [analytics]="AnalyticEvent.UserLogout"
              data-testid="header_profile_logout">
              <span class="dropdown-item-icon">
                <img src="{{skinning.getImage('icon_settings_menu_logout')}}" />
              </span>
              <span>
                {{'settings.logout' | transloco}}
              </span>
            </a></li>
        </ul>
      </div>
    </span>
    }
    }
    @if (minimalHeader) {
    }
  </div>
</div>
@if (sidebarDisplayed) {
<div class="sidebar-shadow" (click)="toggleSidebar()"></div>
}
